import { Summary } from "./formats/summary"
import { Processing } from "./formats/processing"
import { Action } from "./formats/action"

export const Formats = {
  summary: Summary,
  processing: Processing,
  action: Action
}
